import { useEffect } from 'react'
import queries from '../../api/queries'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { setAllMembers, setCurrentUser } from '../../redux/reducers/messenger/chatSlice'
import { openCloseSidebar, setMobileMenu, setProfileToggle } from '../../redux/reducers/messenger/messengerSlice'
import MainSidebar from '../messenger/MainSidebar'
import CallManager from '../messenger/call'
import ChatBoard from '../messenger/chat'
import LeftSidebarChat from '../messenger/left-sidebar-chat'
import ProfileSection from '../messenger/left-sidebar-chat/profile-section'
import { useMessageSelection } from '../messenger/chat/chat-area/chat/message-action/useMessageSelection'
import '../customizer/ApplySavedChatWallpaper'
import '../customizer/initWallpaper'
import { getShadowRoot } from '../../Webcomponent/utils/common'

const Messages = () => {
  const dispatch = useAppDispatch()
  const { data: contactsResponse, isError } = queries.useGetContactList(1, 20)
  // const [loading, setLoading] = useState(true);
  const { data: currentUserData } = queries.useGetUserDetails()
  const { selectedUser } = useAppSelector((state) => state.chat)
  const { mobileMenu, newModal } = useAppSelector((state) => state.messenger)
  const { clearSelection } = useMessageSelection()

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.classList.add('main-page')
      return () => {
        document.body.classList.remove('main-page')
      }
    }
  }, [])

  useEffect(() => {
    if (currentUserData?.user) {
      dispatch(setCurrentUser(currentUserData?.user))
    }
  }, [currentUserData, dispatch])

  useEffect(() => {
    const contacts = contactsResponse?.contacts
    dispatch(setAllMembers(contacts || []))
  }, [contactsResponse, dispatch])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const applyLayout = () => {
        const isNowMobile = window.innerWidth <= 800
        const sidebarToggle = getShadowRoot()?.querySelector('.sidebar-toggle')
        if (isNowMobile) {
          dispatch(openCloseSidebar(false))
          dispatch(setMobileMenu(false))
          sidebarToggle?.classList.add('mobile-menu')
        } else {
          dispatch(openCloseSidebar(true))
          dispatch(setMobileMenu(false))
          sidebarToggle?.classList.remove('mobile-menu')
        }
      }

      let lastWidth = window.innerWidth
      const handleResize = () => {
        if (window.innerWidth === lastWidth) return
        lastWidth = window.innerWidth
        applyLayout()
      }

      applyLayout()
      window.addEventListener('resize', handleResize)

      return () => window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (typeof document === 'undefined') return

    const STYLE_ID = 'dbc-host-footer-zfix'

    const lowerFooter = () => {
      if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement('style')
        style.id = STYLE_ID
        style.textContent = 'body .footer_nav, body .footer_nav.mbl-show { z-index: auto !important; }'
        document.head.appendChild(style)
      }
      document
        .querySelectorAll<HTMLElement>('.footer_nav')
        .forEach((el) => el.style.setProperty('z-index', 'auto', 'important'))
    }

    const restoreFooter = () => {
      document.getElementById(STYLE_ID)?.remove()
      document.querySelectorAll<HTMLElement>('.footer_nav').forEach((el) => el.style.removeProperty('z-index'))
    }

    const container = getShadowRoot()?.querySelector('.meetzy-container')

    const update = () => {
      const conversationOpen = !!container?.classList.contains('mobile-menu')
      const anyModalOpen = Array.isArray(newModal) && newModal.some(Boolean)
      if (conversationOpen || anyModalOpen) lowerFooter()
      else restoreFooter()
    }

    update()

    let observer: MutationObserver | undefined
    if (container) {
      observer = new MutationObserver(update)
      observer.observe(container, { attributes: true, attributeFilter: ['class'] })
    }

    return () => {
      observer?.disconnect()
      restoreFooter()
    }
  }, [mobileMenu, newModal])

  // Toggle mobile-menu class based on mobileMenu state
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const sidebarToggle = getShadowRoot()?.querySelector('.sidebar-toggle')
      if (window.innerWidth <= 800) {
        if (mobileMenu) {
          sidebarToggle?.classList.add('mobile-menu')
        } else {
          sidebarToggle?.classList.remove('mobile-menu')
        }
      }
    }
  }, [mobileMenu])

  useEffect(() => {
    dispatch(setProfileToggle(false))
  }, [selectedUser])

  useEffect(() => {
    clearSelection()
  }, [selectedUser?.chat_id, clearSelection])

  useEffect(() => {
    return () => {
      clearSelection()
    }
  }, [clearSelection])

  // if (loading) {
  //   return (
  //     <div className="loader-wrapper">
  //       <div className="loader-box">
  //         <div className="loader-3" style={{width:'100%'}}>
  //           <SkeletonLoader />
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  if (isError) {
    return (
      <div className="error-wrapper">
        <div className="alert alert-danger">Failed to load contacts</div>
      </div>
    )
  }

  return (
    <div className="widgetWrapper messageModule">
      <div className="meetzy-container sidebar-toggle all-messages">
        <MainSidebar />
        <LeftSidebarChat />
        <ChatBoard />
        <ProfileSection />
        <CallManager />
      </div>
    </div>
  )
}

export default Messages
